import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
    supportedLngs: ['en', 'es'],
    fallbackLng: 'en',
    preload: ['en', 'es'],
    debug: false, // Enable debug to see translation logs
    backend: {
        loadPath: './assets/translations/{{lng}}.json',
    },
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false, // Prevent suspense issues
    },
});
export default i18n;
